import { Component, Input, OnChanges, TrackByFunction } from '@angular/core';

import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';
import { ThemeInverse } from '@frontend/sports/common/ui/shared';

import { ShowcaseEventModel } from '../showcase.model';
import { ShowcaseService } from '../showcase.service';
import { ShowcaseTrackingService } from '../showcase.tracking.service';

@Component({
    selector: 'ms-showcase-tab-bar',
    templateUrl: 'showcase-tab-bar.component.html',
    standalone: false,
})
export class TabsShowcaseComponent implements OnChanges {
    @Input() events: ShowcaseEventModel[];
    @Input() scrollEnabled = true;
    @Input() selectedEventId: string;
    activeEventid: string;
    themeInverseIndicator: ThemeInverse;

    constructor(
        private showcaseService: ShowcaseService,
        private showcaseTrackingService: ShowcaseTrackingService,
    ) {
        this.themeInverseIndicator = {
            bwin: { isInverse: true },
        };
    }

    ngOnChanges(changes: ISimpleChanges<TabsShowcaseComponent>): void {
        if (changes.selectedEventId) {
            this.activeEventid = changes.selectedEventId.currentValue;
        }
    }

    selected(domEvent: Event, event: ShowcaseEventModel, index: number): void {
        domEvent.preventDefault();
        this.showcaseService.eventSelectedFromTabBar = true;
        this.showcaseService.select(event.event.id);
        this.showcaseTrackingService.trackEventSwitcherEventClick(event.event, index);
    }

    trackTabsBy: TrackByFunction<ShowcaseEventModel> = (index, model) => {
        return model.event.id;
    };
}
